import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { WeatherDisplayModel } from 'src/app/core/services/weather-forecast.service';

@Component({
  selector: 'app-weather-renderer',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './weather-renderer.component.html',
  styleUrl: './weather-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherRendererComponent {
  @Input({ required: true }) public weather: WeatherDisplayModel;
  @Input() isFetching: boolean = false;
  @Input() wrapperClass: string[] = ['mt-3', 'mb-3'];

  public isFahrenheit: boolean = false;

  constructor(protected readonly breakpointService: BreakpointService) {}

  public roundTemperature(val: number): number {
    return Math.round(val);
  }

  public preventDefault(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();
  }
}
